import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";

import { IBusinessTransactionsListData } from "./types";

export const BUSINESS_TRANSFERS_TRANSACTIONS_COLUMN = [
  "Date and Time",
  "Customer",
  "Reference",
  "Type",
  "Amount",
  "Description",
  "Status",
  "",
];

export const BUSINESS_BILL_PAYMENTS_TRANSACTIONS_COLUMN = [
  "Customer",
  "Reference",
  "Amount",
  "Description",
  "Status",
  "Date and Time",
  "",
];

export const PAGE_LIMIT = 5;
export const DEFAULT_BUSINESS_TRANSACTIONS_PAGE_LIMIT = 10;
export const DEFAULT_BUSINESS_TRANSACTIONS_PAGINATION_PARAMS: IPaginationParams =
  {
    page: PAGE_ONE,
    limit: DEFAULT_BUSINESS_TRANSACTIONS_PAGE_LIMIT,
  };

// Add constants for magic numbers
const HALF = 0.5;

// Add constant for probability threshold
const PROBABILITY_THRESHOLD = 0.5;

// Helper function to randomly assign type
const getRandomType = () =>
  Math.random() < PROBABILITY_THRESHOLD ? "credit" : "debit";

export const transfersData: IBusinessTransactionsListData[] = [
  {
    id: "1",
    customer: "Black Sheep Inc.",
    customerType: "Individual",
    reference: "TRF-1729736726727",
    amount: "₦400,000",
    description: "Payment for project completion",
    status: "Successful",
    dateAndTime: "1st Apr, 2024 at 10:00am",
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
    email: "contact@blacksheep.com",
    type: getRandomType(),
  },
  {
    id: "2",
    customer: "Blue Ocean LLC",
    customerType: "Business",
    reference: "TRF-9837462837462",
    amount: "₦750,000",
    description: "Monthly subscription fee",
    status: "Pending",
    dateAndTime: "15th May, 2024 at 11:30am",
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
    email: "info@blueocean.com",
    type: getRandomType(),
  },
  {
    id: "3",
    customer: "Green Valley Ltd.",
    customerType: "Business",
    reference: "TRF-8473629182736",
    amount: "₦1,200,000",
    description: "Payment for consulting services",
    status: "Failed",
    dateAndTime: "12th Jun, 2024 at 9:45am",
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
    email: "support@greenvalley.com",
    type: getRandomType(),
  },
  {
    id: "4",
    customer: "Sunrise Ventures",
    customerType: "Individual",
    reference: "TRF-2938475628374",
    amount: "₦850,000",
    description: "Investment return",
    status: "Successful",
    dateAndTime: "5th Jul, 2024 at 3:30pm",
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
    email: "admin@sunriseventures.com",
    type: getRandomType(),
  },
  {
    id: "5",
    customer: "Tech Innovators",
    customerType: "Business",
    reference: "TRF-3847562938475",
    amount: "₦600,000",
    description: "Service fee for software development",
    status: "Pending",
    dateAndTime: "20th Aug, 2024 at 11:00am",
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
    email: "hello@techinnovators.com",
    type: getRandomType(),
  },
];

export const billsPaymentsData: IBusinessTransactionsListData[] = [
  {
    id: "6",
    customer: "Blue Sky Corp.",
    customerType: "Individual",
    reference: "TRF-9283746528374",
    amount: "₦150,000",
    description: "Electricity bill payment",
    status: "Successful",
    dateAndTime: "8th Sep, 2024 at 4:15pm",
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
    email: "billing@bluesky.com",
    type: getRandomType(),
  },
  {
    id: "7",
    customer: "Red Brick Co.",
    customerType: "Business",
    reference: "TRF-1827364958273",
    amount: "₦80,000",
    description: "Internet service subscription",
    status: "Pending",
    dateAndTime: "25th Oct, 2024 at 10:00am",
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
    email: "accounts@redbrick.com",
    type: getRandomType(),
  },
  {
    id: "8",
    customer: "Golden Gate Enterprises",
    customerType: "Individual",
    reference: "TRF-3847562938475",
    amount: "₦250,000",
    description: "Water utility payment",
    status: "Successful",
    dateAndTime: "15th Nov, 2024 at 2:45pm",
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
    email: "info@goldengate.com",
    type: getRandomType(),
  },
  {
    id: "9",
    customer: "Silver Line Inc.",
    customerType: "Business",
    reference: "TRF-9283746528374",
    amount: "₦120,000",
    description: "Gas utility payment",
    status: "Pending",
    dateAndTime: "30th Dec, 2024 at 1:30pm",
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
    email: "contact@silverline.com",
    type: getRandomType(),
  },
  {
    id: "10",
    customer: "Urban Solutions",
    customerType: "Individual",
    reference: "TRF-1827364958273",
    amount: "₦95,000",
    description: "Phone bill payment",
    status: "Failed",
    dateAndTime: "10th Jan, 2025 at 5:00pm",
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
    email: "support@urbansolutions.com",
    type: getRandomType(),
  },
];

export const businessTransactionsListData: IBusinessTransactionsListData[] = [
  ...transfersData,
  ...billsPaymentsData,
];

// Use constant instead of magic number
export const someFunction = () => {
  // ... existing code ...
  return HALF;
};
